import { FlowManager } from '../flow-management/FlowManager';
import { Step } from '../views/Step';
export const getFlowStepsWithEmailVerification = flowSteps => {
  const preVerificationSteps = FlowManager.replaceStep(Step.CodeVerification, Step.Verification)(flowSteps.preVerification);
  return {
    preVerification: preVerificationSteps,
    postVerification: flowSteps.postVerification,
    postAccountCreation: flowSteps.postAccountCreation,
    postExistingAccountSelection: flowSteps.postExistingAccountSelection
  };
};